/********************************************************
 * Third Controls
 ********************************************************/
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import { useSelector, connect, useDispatch } from 'react-redux';
import { Icon, Grid } from '@mui/material';
import moment from 'moment';

/********************************************************
 * Controls / Objects
 ********************************************************/
import { Button, InputSearch, Loading, Tooltip } from 'Components';
import ListItems from 'Components/ListItems'
import { getEventColor } from '../../../../../../../components/Map/utils'
import { getVidFleetEvent,getSwitnessEvent } from 'Core/data/VideoEvents';
import { NotificationManager } from 'Components/Notifications';
import { ExportButton } from 'Components/Table/Toolbar';
import useExport from 'Components/Table/Export';
import { cutNotes, convertWhiteColor, getFormattedDateByTimeZone, formatAddress, postedSpeedColor, removeAccents, speedFormatMPH } from '../../../../../../../core/data/Helpers';
import {Timezone} from 'Components/uiControls';

import VehicleTrailList from './vehicleTrailList';

import { TypeObjectMap } from '../../../../../../../components/Map/providers/enums'


/********************************************************
 * Actions
 ********************************************************/
 import { 
  updateShowVehicleTrailsTable, 
  centerOnUnit, 
  getVehicleTrails,
  mapLandmarksOpenEditCreateModalWithParams,
  sendGenericExport,
  clearRedux
 } from 'Redux/actions';

import { setTrailPreviewData } from 'Modules/.common/components/InfoBubble/redux/slice';

 import { useIntl } from "react-intl";

/********************************************************
 * Style
 ********************************************************/
import './style.scss'
import { translateEvent } from '../../../../../../.common/utils/translateEvents';
import { mapInputEventName } from '../../../../../../.common/utils/translateEvents';
import { useUnitInputs } from 'Core/hooks';
import { unitSelectors } from 'Core/realtime/redux/unitSlice';

const consolidateEvents = [
  'Idle',
  'Drive',
  'Travel Start',
  'Motion',
  'Motion Start'
]

/********************************************************
 * Icon marker to realtime maps
 ********************************************************/
const IconMarker = (props) => {
  const { color = 'orangered', url, name } = props;
  if (url) {
    return (
      <img src={url} alt={name} style={{ width: 25, height: 25 }} />
    );
  }

  return (
    <svg className="markerIcon" xmlns="http://www.w3.org/2000/svg" 
          //transform={`rotate(${props.heading})`}
          width="40" height="40" viewBox="0 0 40 40" aria-labelledby="title">
      <title id="title">{name}</title>
      <path fill={color} d="M 2.64,20.41
                    C 2.64,20.41 19.57,11.59 19.57,11.59
                    19.57,11.59 2.64,3.27 2.64,3.27
                    2.64,3.27 5.46,11.59 5.46,11.59
                    5.46,11.59 2.64,20.41 2.64,20.41 Z"/>
    </svg>
  )
}

 /********************************************************
 * Get the addres from the trail
 ********************************************************/
const TrailAddress = (props) => {
  const { trail, landmarkGroups, landmarkName, item, dispatch, messages } = props;

  //let color = getEventColor(trail?.eventName);
  let color = 'black';
  if (landmarkGroups && landmarkGroups.length) {
    let landmarkGroup = landmarkGroups.find(lg => lg.id == trail?.landmark?.groupId);
    if (landmarkGroup) color = convertWhiteColor(landmarkGroup?.color);
  }

  return (
    <React.Fragment>
      {
        <Grid
          container
          wrap='nowrap'
        >
          <Grid item>
            <Icon
              style={{
                color: color,
                fontSize: 18,
                padding: 2
              }}
            >
              flag
            </Icon>
          </Grid>
          <Grid item style={{ paddingTop: 3}}
            onClick={()=>{
              if(!landmarkName){
                //dispatch to open the modal to create landmark on realtime maps
                dispatch(mapLandmarksOpenEditCreateModalWithParams(true, item, 'vehicleTrails'));
              }     
            }}
          >
            {/* Create new Landmark */}
            <label style={landmarkName ? {} : { cursor: 'pointer' }} >{landmarkName ? landmarkName : messages['mapLandmarkCreateEditLandmark_createLandmark']}</label>
          </Grid>
        </Grid>
      }
    </React.Fragment>
  )
}

const TimeZoneControl = (props) => {
  const { row, timeZone, locale } = props;
  return (
    <Grid item xs zeroMinWidth>
      <div style={{ display: "flex" }}>
          <Timezone
              date={new Date(row?.unitTime)}
              dateFormat={"dddd, MMMM DD YYYY"}
              timeFormat="hh:mm:ss a"
              timezone={timeZone}
              className="labelTrailDate"
              customFormat={true}
              locale={locale}
              noWrap={false}
              oneControl={true}
          /> 
      </div>
  </Grid>
  )
}

/********************************************************
 * Create array to show elements into the grid
 ********************************************************/
const createDataToShow = (vehicleTrails, landmarkGroups, messages, prefSettings = null, vehicle, lang, timeZone, dispatch, dataByVicinityTool, unitInputs) =>{
  let data = [], dataToExport = [];
  let isConsolidate = true;
  const effectiveTimeZone = vehicle?.timeZone?.name || timeZone;
  try {
    if (vehicleTrails && vehicleTrails?.items?.length > 0) {
        let showWayPoint = false;
        let showTrailLines = true;
        if(prefSettings){
            const { trailShowWaypointNumbers, trailConnectingLine } = prefSettings;
            if(trailShowWaypointNumbers) showWayPoint = true;
            showTrailLines = trailConnectingLine == undefined ? true : trailConnectingLine;
        }

        let vehicleTrailsItems = vehicleTrails.items;
        isConsolidate = showTrailLines ? true : false;
        let consolidateCard = null , indexConsolidateCard = 0;
        let lastEventTime = null
        vehicleTrailsItems.forEach((element, index) => {
            let newAddress = formatAddress(element) || 'N/A';
            let landmarkAdress = '';
            let landmarkName = '';

            if (element?.landmark) {
              let lAddress = '', lCity = '', lState = '', lZip = '', lCountry = '';
              lAddress = element?.landmark?.address ? ` ${element?.landmark?.address}` : '';
              lCity = element?.landmark?.city ? `, ${element?.landmark?.city}` : '';
              lState = element?.landmark?.state ? `, ${element?.landmark?.state}` : '';
              lZip = element?.landmark?.zip ? `, ${element?.landmark?.zip}` : '';
              lCountry = element?.landmark?.country ? `, ${element?.landmark?.country}` : '';
              //landmarkAdress = `(${element?.landmark?.name}) ${lAddress}${lCity}${lState}${lZip}${lCountry}`;
              landmarkAdress = `(${element?.landmark?.name}) ${newAddress}`;
              landmarkName = element?.landmark?.name || '';
            } 

            let color;
            let icon = <IconMarker color={getEventColor(element?.eventName)} name={element?.eventName}  />;
            let event;

            if (element?.eventCode && element?.eventCode?.includes("CameraEvent")) {
              event = getVidFleetEvent(element?.eventCode);
              color = event?.color;
              icon = <IconMarker url={event?.icon} name={element?.eventName} />;
            }


            if(element?.unitType==="switness"){
              event = getSwitnessEvent(element?.eventCode);
              color = event?.color;
              icon = <IconMarker url={event?.icon} name={element?.eventName} />;
            }

            const newLandmark = {
              type: 'circle',
              landmarkIcon: false,
              tags: null,
              color: null,
              radius: 20,
              address: newAddress,
              latitude: element.latitude, 
              longitude: element.longitude,
              typeGeo: { id: 2, shape: 'circle', type: TypeObjectMap.Circle, name: messages['mapLandmarkCreateEditLandmark_circle'], maxPoints: 0 }
            }

            // Map input event names to custom labels
            const mappedEventName = mapInputEventName(element?.eventName, unitInputs) || element?.eventName;
            const displayEventName = event && event?.lanKey ? messages[event?.lanKey] : (mappedEventName || 'N/A');

            let newElement = {

              id: element.id,
              deviceId: element.deviceId,
              address: newAddress,
              driverName: element.driverName && element.driverId > 0 ? element.driverName || '' : '',
              driverId: element.driverId || 0,
              heading: element.heading || 0,
              
              latitude: element.latitude,
              longitude: element.longitude,
              name : showWayPoint ? `${element?.wayPoint} - ${displayEventName}` : displayEventName,
              color: color || getEventColor(element?.eventName),
              postedSpeedColor: postedSpeedColor(element.speed, element.speedLimit),
              
              eventName: element.eventName,
              unitTime: element.unitTime,
              formatedTime: getFormattedDateByTimeZone(element?.unitTime, effectiveTimeZone, messages, "MM/DD/YYYY",false ,lang) || '',
              description: getFormattedDateByTimeZone(element?.unitTime, effectiveTimeZone, messages, "dddd, MMMM DD YYYY, hh:mm:ss a",false ,lang) || '',
              landmarkName: landmarkName,
              landmarkGroups: landmarkGroups,
              speed: element.speed, 
              speedLimit: element?.speedLimit,
              overSpeed: element.speedLimit > 0 && element.speed > element.speedLimit ? Math.abs(element.speed - element.speedLimit) : 0,

              eventColor: element?.eventColor,
              vehicleTimezone: effectiveTimeZone,
              unitType: element.unitType,
              landmarkObject: <TrailAddress item={newLandmark} trail={element} landmarkGroups={landmarkGroups} landmarkName={landmarkName} dispatch={dispatch} messages={messages} />,
              children: [],
              trail: element?.trail || null
          }


          if(isConsolidate){
            //if consolidate card.
            if(data.length > 0 && data[data.length -1].eventName != element.eventName) {
              lastEventTime = data[data.length -1]?.children?.at(-1)?.unitTime || data?.at(-1)?.unitTime || null
            }
            if(data.length > 0 && data[data.length -1].eventName == element.eventName && consolidateEvents.includes(element.eventName)){
              if(consolidateCard == null){
                indexConsolidateCard = data.length -1;
                const oldRegistry = {...data[data.length -1]}
                consolidateCard = { 
                  ...oldRegistry, 
                  finalAddress: oldRegistry.address, 
                  maxSpeed: oldRegistry.speed, 
                  maxOverSpeed: oldRegistry.overSpeed,
                  unitTime: lastEventTime || oldRegistry.unitTime
                }
                lastEventTime = null
                consolidateCard.children = [];
                //add the last element to the children consolidate data
                consolidateCard.children.push({...oldRegistry })
              }

              const date1 = moment(element.unitTime);
              const date2 = moment(consolidateCard.unitTime);

              // Obtener la diferencia de tiempo entre date2 y date1
              const diff = date2.diff(date1);
                            
              consolidateCard = {
                ...consolidateCard, 
                totalDurationOnSpeed: diff,
                address: consolidateCard.address,
                finalAddress: newElement.address,
                maxSpeed: newElement.speed > (consolidateCard?.maxSpeed || 0 ) ? newElement.speed : consolidateCard.maxSpeed,
                maxOverSpeed: newElement.overSpeed > (consolidateCard?.maxOverSpeed || 0) ? newElement.overSpeed : consolidateCard.maxOverSpeed
              }
              //const lastElement = data[data.length -1]
              consolidateCard.children.push(newElement) 

              //update the consolidate card data
              data[indexConsolidateCard] = consolidateCard;
            }else{
              //deberia de ir aqui la carta de consolidación.
              data.push(newElement)
              consolidateCard = null;
            }
            dataToExport.push(newElement);

          }else{
            data.push(newElement)
          }
      });
    }
  } catch(ex) {
    if(!dataByVicinityTool?.length){
      NotificationManager.warning(
        messages['realtimemaps_vehicletrails_vehicletrail_err'],
        messages['realtimemaps_vehicletrails_vehicletrail_table'],
        3000,
        null,
        null,
        'warning',
        null
      );
    }
  }

  return { data, dataToExport};
}

/*********************************************************
 * Author:  Walter Paz Londoño
 * Date:    24 Abr 2020
 * Module:  Realtime Maps
 * 
 * Class associated to the Vehicle Trails elements
 ********************************************************/
const VehicleTrailsTable = (props) => {
  const { mapRef, paramFilter, paramSetFilter } = props
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const tarjetaRef = useRef();

  const [valueFilter, setvalueFilter] = useState('')

  const filter = paramFilter ? paramFilter : valueFilter
  const setFilter = paramSetFilter ? paramSetFilter : setvalueFilter

  const landmarkGroups = useSelector((state) => state.entitySelectorRedux.landmarkGroups);
  const preferencesUser = useSelector((state) => state.preferencesRedux.preferencesUser);
  const lang = useSelector(state => state.commomRedux.language);

  const vehicleTrails = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.vehicleTrails);
  const vehicletrailsPrint = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.vehicletrailsPrint);
  const loadVehicleTrails = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.loadVehicleTrails);
  const unitToPrint = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.unitToPrint);
  const unitVehicleTrails = useSelector(state => state.vehicleTrailsSliceRedux.unitVehicleTrails);
  const paramsVehicleTrails = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.paramsVehicleTrails);
  const exportData = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.exportData);
  const timeZone = useSelector((state) => state.securityRedux.user.timeZone);
  const kph = useSelector((state) => state.securityRedux.user.isKph);
  const idClickMarkerTrails = useSelector(state => state.realtimeMapUtilitiesvehiclesTrailRedux.idClickMarkerTrails);
  const dataByVicinityTool = useSelector(state => state.realtimeMapsVicinityTool.result);

  const exportResult = useSelector((state) => state.commomRedux.exportResult);
  const exportName = useSelector((state) => state.commomRedux.exportName);

  const keyPreferences = "mapSettings";
   // -------------- declare State -----------------
   const [prefSettings, setPrefSettings] = useState()
   const [paramSearch, setParamSearch] = useState()
   const [vehicle , setVehicle] = useState(unitToPrint || unitVehicleTrails)

  // Fetch unit inputs for custom input label mapping
  const { unitInputs, loading: unitInputsLoading } = useUnitInputs(vehicle?.id);

  // Manufacturer of the trail's unit, for the OEM data action on each card (realtime catalog first).
  const realtimeManufacturerName = useSelector(state => unitSelectors.selectById(state, String(vehicle?.id))?.manufacturerName);
  const oemUnit = useMemo(() => ({
    id: vehicle?.id,
    label: vehicle?.label || vehicle?.Label,
    manufacturerName: realtimeManufacturerName ?? vehicle?.manufacturerName,
  }), [vehicle?.id, vehicle?.label, vehicle?.Label, vehicle?.manufacturerName, realtimeManufacturerName]);

   /********************************************************
    * Load the starting filters
    ********************************************************/
    useEffect(()=> {
        if(paramsVehicleTrails && !paramSearch){
            setParamSearch(paramsVehicleTrails)
        }
    },[paramsVehicleTrails])

    useEffect(()=> {
      const source = unitToPrint || unitVehicleTrails;
      if(source && !vehicle){
        setVehicle(source) 
      }
    },[unitToPrint, unitVehicleTrails])

    useEffect(()=> {
      if(idClickMarkerTrails != null){
        
        //select card on the elements on grid
        const tarjeta = tarjetaRef?.current?.querySelector(`#item-${idClickMarkerTrails}`);
        if (tarjeta) {
          tarjeta.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

      }
    },[idClickMarkerTrails])

    useEffect(() => {
      //refresh the control
    }, [prefSettings?.trailConnectingLine]);

  useEffect(() => {
      if (exportResult && exportName === "vehicleTrails") {
        NotificationManager.info(
          messages["exportInProcessBody"],
          messages["exportInProcessTitle"],
          4000,
          null,
          null,
          "info",
          null
        );
        dispatch(clearRedux("COMMON", { exportResult: null, exportName: null }));
      }
  }, [exportResult, exportName]);
  

  /********************************************************
   * Event to return the main view to vehicle trails
   ********************************************************/
  const closeVehicleTrailsTable = (event) =>{
    event.preventDefault()
    dispatch(updateShowVehicleTrailsTable(false));
  }

  /********************************************************
  * Select the marker on the map
  ********************************************************/
  const onClickItem = useCallback((item) => {
    // Store local row data immediately so InfoBubble can render the Location
    // tab (address, speed, event, time, lat/lng) before the API responds.
    dispatch(setTrailPreviewData({
      id: item.id,
      eventName: item.eventName,
      address: item.address,
      speed: item.speed,
      speedLimit: item.speedLimit,
      unitTime: item.unitTime,
      latitude: item.latitude,
      longitude: item.longitude,
      driverName: item.driverName || '',
      driverId: item.driverId || 0,
      heading: item.heading || 0,
      unitType: item.unitType,
      vehicleTimezone: item.vehicleTimezone,
    }));

    dispatch(centerOnUnit(0));
    
    if (window.openInfoBubbleFromVehicleTrails) {
      clearTimeout(window.openInfoBubbleFromVehicleTrails)
    }

    window.openInfoBubbleFromVehicleTrails = setTimeout(() => {
      dispatch(centerOnUnit(item.id, false, true))
      window.openInfoBubbleFromVehicleTrails = null;
    }, 150);
  }, [dispatch]);

  /*********************************************************
   * Load the preference mapSettings values prevenge reload
  *********************************************************/
  useEffect(()=>{
    try {
        if (preferencesUser) {
        const mapSettings = preferencesUser.find(preference => preference.preferenceKey === keyPreferences);
        if (mapSettings && mapSettings?.preferenceValue && typeof mapSettings?.preferenceValue === "string") {
            if (JSON.stringify(prefSettings) != mapSettings.preferenceValue) {
                let preferences = JSON.parse(mapSettings.preferenceValue);
                if (typeof preferences === "string") preferences = JSON.parse(preferences);
                    setPrefSettings({...preferences});
                }
            }
        }
    } catch (e) {
        NotificationManager.error('Error', `Error /components/VehicleTrailsTable/ useEffect- preferencesUser - ${e}`, 3000, null, null, 'error');
    }
  },[preferencesUser])

  /********************************************************
  * Format the speed value
  ********************************************************/
  const getSpeed = () => {
    return `let newSpeed = row?.ecuSpeed ? row?.ecuSpeed : row?.speed; if (!newSpeed) return ""; ${
      kph
        ? ` let kph = 0; if (parseInt(newSpeed) > 0) { kph = (newSpeed * 1.609344); } return Math.ceil(kph) + " KPH";`
        : ` let speed = Math.round(newSpeed); return speed + " MPH" `
    }`;
  };

  /********************************************************
  * Validate is PDF of CSV export
  ********************************************************/
  const onExport = (valueFile) => {
    let paramToGetTrails = {
        ...paramsVehicleTrails,
        offset: 0,
        limit: paramsVehicleTrails?.total,
        deviceId: paramsVehicleTrails?.unitId
    }
    
    if (paramsVehicleTrails?.event == '0') {
      delete paramToGetTrails["event"]
    }
    if (!paramToGetTrails?.openSearch) {
      delete paramToGetTrails["openSearch"]
    } 

    const tableHeader = [{ name: messages["realtimemaps_vehicletrails_unit"], value: vehicle?.label || vehicle?.Label || ""}];

    const eventNameDict = (vehicleTrails?.items ?? []).reduce((acc, it) => {
      if (it?.eventName && !acc[it.eventName]) {
        acc[it.eventName] = mapInputEventName(it.eventName, unitInputs) || translateEvent(it.eventName, messages);
      }
      return acc;
    }, {});

    let columns = [
      { 
        header: messages['realtimemaps_vehicletrails_unit'], 
        column: 'name', 
        functionString: `return "${vehicle?.label || vehicle?.Label}";` 
      },
      { 
        header: messages['generatedReport_driver'], 
        column: 'driverName', 
        functionString: `return row.driverName && row.driverId > 0 ? row.driverName || "" : ""` 
      },
      { header: messages['realtimemaps_vehicletrails_event'], 
        column: 'eventName', 
        functionString: `
          const dict = ${JSON.stringify(eventNameDict)};
          const key = row?.eventName;
          return dict[key] || key || "";
        `
      },
      { header: messages['realtimemaps_vehicletrails_latitude'], 
        column: 'latitude', 
        functionString: 'return row?.latitude != null ? Number(row.latitude).toFixed(6) : ""' 
      },
      { header: messages['realtimemaps_vehicletrails_longitude'], 
        column: 'longitude', 
        functionString: 'return row?.longitude != null ? Number(row.longitude).toFixed(6) : ""' 
      },
      { header: messages['realtimemaps_vehicletrails_date'], 
        column: 'formatedTime', 
        functionString: `
          function getFormattedDateByTimeZone(date, timeZone, format, locale = "en") {
            let momentDate = "";
            moment.locale(locale);

            if (!date || !timeZone) return;

            if (Number.isInteger(date * 1)) {
              if (date.toString().length > 10) date = date / 1000;
              momentDate = moment.unix(date).tz(timeZone);
            } else if (typeof date === "string") {
              momentDate = moment(date).tz(timeZone);
            }

            if (!momentDate) return;

            if (format) {
              return momentDate.format(format);
            }

            if (moment().tz(timeZone).isSame(momentDate, "day")) {
              return locale === "en"
                ? "Today at " + momentDate.format("h:mm A")
                : "Hoy a las " + momentDate.format("h:mm A");
            } else if (moment().tz(timeZone).subtract(1, "day").isSame(momentDate, "day")) {
              return locale === "en"
                ? "Yesterday at " + momentDate.format("h:mm A")
                : "Ayer a las " + momentDate.format("h:mm A");
            }

            return momentDate.format("Y/m/d h:mm A");
          }

          return getFormattedDateByTimeZone(row?.unitTime, "${vehicle?.timeZone?.name || timeZone}", "dddd, MMMM DD YYYY, hh:mm:ss a", "${lang}") || "";
        `
      },
      { header: messages['generatedReport_speed'], 
        column: 'speed', 
        functionString: getSpeed()},
      { header: messages['generatedReport_address'], 
        column: 'address', 
        functionString: 'return row?.landmark?.name ? `(${row?.landmark?.name}) ${row?.formattedAddress}` : row?.formattedAddress;',
        
      }
    ];

    // If the export is PDF, remove the first column (unit) to avoid duplication
    if (valueFile !== "CSV") {
      columns = columns.filter((_, index) => index !== 0);
    }

    const addressColumnIndex = columns.findIndex(({ column }) => column === 'address');
    const columnStyles = addressColumnIndex >= 0
      ? { [addressColumnIndex]: { cellWidth: 140 } }
      : {};

    dispatch(sendGenericExport(
                "vehicleTrails",
                valueFile == "CSV" ? "Csv" : "Pdf",
                `query searchVehicleTrails ($startDate: AWSDateTime!, $endDate: AWSDateTime!, $event: VehicleTrailEvent, $deviceId: String!, $openSearch: String, $limit: Int, $offset: Int, $includeLinkedData: Boolean, $withRecentEvent: Boolean) {
                    Trails: searchVehicleTrails (startDate: $startDate, endDate: $endDate, event: $event, deviceId: $deviceId, openSearch: $openSearch, limit: $limit, offset: $offset, includeLinkedData: $includeLinkedData, withRecentEvent: $withRecentEvent) {
                        items {
                            driverId
                            driverName
                            eventName
                            latitude
                            longitude
                            unitTime
                            speed
                            ecuSpeed
                            formattedAddress
                            landmark {
                              name
                            }
                        }
                        total
                    }
                }`,
                paramToGetTrails,
                columns,
                { unit: 'pt', size: 'A4', orientation: 'landscape', fontSize: 10 },
                tableHeader,
                null,
                null,
                columnStyles
            ));

  }

    /******************************************************
     * Get the new filter for events
     * @param {String} filterValue address value
     ******************************************************/
    const filterEvents = useCallback((value) => {
        setFilter(value);

        if (window.typingTime) {
            clearTimeout(window.typingTime);
        }

        window.typingTime = setTimeout(() => {
            SearchByType(value)
            window.typingTime = null;
        }, 1000);
    }, [paramSearch, prefSettings, vehicle]);

    /*********************************************************
     * Call the save preferences and restart the timer
     *********************************************************/
    const SearchByType = (filterValue) => {
        const paramToGetTrails = {
            ...paramSearch,
            openSearch: filterValue ? filterValue : '', // to change this line
            limit: prefSettings?.trailRowsPerPage || 100,
            offset: 0,
        }
        dispatch(getVehicleTrails(paramToGetTrails, vehicle?.label))
    }

    const items = useMemo(() => {
      return createDataToShow(vehicleTrails, landmarkGroups, messages, prefSettings, vehicle, lang, timeZone, dispatch, dataByVicinityTool, unitInputs).data;
    }, [vehicleTrails, landmarkGroups, prefSettings, vehicle, lang, timeZone, dataByVicinityTool, unitInputs]);
  return(
    <Grid container spacing={0}>
      {
        (vehicle?.label || vehicle?.Label) &&
        <Grid item container sm={12} style={{ paddingBottom: 5}}>
          <Grid item sm={2}>
            <span>{`${messages['unit_value']}:`}</span>
          </Grid>
          <Grid item sm={10} style={{ display: 'flex' }}>
            {(vehicle?.label || vehicle?.Label)?.length > 30 ? (
              <Tooltip title={vehicle?.label || vehicle?.Label || ''} placement="top">
                <span className='labelTrail'>{vehicle?.label || vehicle?.Label}</span>
              </Tooltip>
            ) : (
              <span className='labelTrail'>{vehicle?.label || vehicle?.Label}</span>
            )}
          </Grid>
        </Grid>    
      }
      <Grid item sm={10}>
        <InputSearch
          searchText={filter}
          onSearch={(param) => setFilter(param)}
          searchWhenFinishedTyping={true}
          onSearchWhenFinish={(param) => filterEvents(param)}
        />
      </Grid>
      <Grid item sm={2}>
        <div style={{ paddingTop: 5}}>
          <ExportButton onExport={onExport} />
        </div>
      </Grid>
      {
        !loadVehicleTrails
        &&
        <Grid item sm={12}>
          <div style={{ 
              padding: 0,
              height: '65vh',
              overflowY: 'auto',
              overflowX: 'hidden',
              width: '100%' }}>
            <VehicleTrailList data={items} onClickItem={onClickItem} mapRef={mapRef} ref={tarjetaRef} prefSettings={prefSettings} oemUnit={oemUnit}></VehicleTrailList>
          </div>
        </Grid>
      }
      {
          loadVehicleTrails
          &&
          <Grid container spacing={0} direction="column" alignItems="center" justifyContent="center" >
            <Grid item xs={3} style={{ paddingTop: 20 }} >
              <Loading />
            </Grid>
          </Grid>
        }
      <Grid item sm={12}>
        {
          dataByVicinityTool.length === 0 && 
          <Button
            id={'btn-save-vehicle-group'}
            type="button"
            onClick={closeVehicleTrailsTable}
            className="btn-blue buttonTrailTable"
        >
          {messages['realtimemaps_vehicletrails_closetable']}
        </Button>
        }
        
      </Grid>
    </Grid>
  )

}

export default VehicleTrailsTable;
